import { useContext, useState } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import logo from "../assets/logo.png";
import { dropdownContent } from "../data/menuDropdowns";
import { FaWhatsapp } from "react-icons/fa";

export default function TopBar() {
  const appContext = useContext(AppContext);
  const [hoverItem, setHoverItem] = useState(null);

  function goTo(nav) {
    appContext.navTo(nav);
    setHoverItem(null);
  }

  const navItems = [
    { id: "home", label: "Home", nav: { item: "home" } },
    { id: "about", label: "About Us", nav: { item: "about_us" } },
    { id: "safaris", label: "Safaris", nav: { item: "services", subItem: "safaris" } },
    { id: "trekking", label: "Trekking", nav: { item: "services", subItem: "trekking" } },
    { id: "zanzibar", label: "Zanzibar", nav: { item: "services", subItem: "zanzibar" } },
    { id: "contact", label: "Contact Us", nav: { item: "contact_us" } },
  ];

  return (
    <div className="TopBar topbar-modern topbar-modern--clean" onMouseLeave={() => setHoverItem(null)}>
      <div className="topbar-modern-body">
        <div className="container topbar-modern-inner">
          <div className="topbar-brand">
            <img
              src={logo}
              alt="Kwetu Africa Adventures"
              style={{ height: 52 }}
              onClick={() => goTo({ item: "home" })}
            />
          </div>

          <div className="topbar-modern-mobile-actions">
            <button
              type="button"
              className="btn btn-primary rounded"
              onClick={() => goTo({ item: "plan-trip" })}
            >
              ENQUIRE
            </button>
            <button type="button" className="topbar-modern-menu-btn" onClick={appContext.openSideBar}>
              <MdMenu size={22} />
            </button>
          </div>

          <div className="topbar-modern-nav-wrap mDesktopOnly">
            <div className="topbar-modern-nav">
              {navItems.map((item) => {
                const hasDropdown = dropdownContent[item.id];
                return (
                  <button
                    key={item.id}
                    className="topbar-modern-link d-flex align-items-center gap-1"
                    onMouseEnter={() => hasDropdown && setHoverItem(item.id)}
                    onClick={() => goTo(item.nav)}
                    type="button"
                  >
                    <span>{item.label}</span>
                    {hasDropdown && <IoMdArrowDropdown size={16} />}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="topbar-modern-actions mDesktopOnly">
            <button
              type="button"
              className="btn btn-primary topbar-modern-cta me-3"
              onClick={() => appContext.navTo({ item: "plan-trip" })}
            >
              ENQUIRE NOW
            </button>
            <a
              className="topbar-modern-expert"
              href="https://wa.me/255676808073"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat with Kwetu Africa expert"
            >
              <FaWhatsapp size={16} />
              <div className="topbar-modern-expert-copy">
                <span className="topbar-modern-expert-label">Ask an Expert</span>
                <span className="topbar-modern-expert-number">+255 676 808 073</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      {hoverItem && dropdownContent[hoverItem] && (
        <div className="mega-dropdown">
          <div className="container">
            <div className="row g-4">
              {dropdownContent[hoverItem].map((card, i) => (
                <div className="col-md-3" key={i}>
                  <div className="mega-card" onClick={() => goTo(card.nav)}>
                    <div className="mega-card-image" style={{ backgroundImage: `url(${card.img})` }} />
                    <div className="mega-card-overlay" />
                    <div className="mega-card-content">
                      <div className="mega-category font-semi-bold">{hoverItem.charAt(0).toUpperCase() + hoverItem.slice(1)}</div>
                      <h6>{card.title}</h6>
                      <div className="duration-pill mt-5">{card.duration}</div>
                      <button className="btn btn-warning btn-rounded btn-sm w-100">View Itinerary</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
